import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Col, Row, Pagination, Button, Form, Modal } from 'react-bootstrap';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Title } from '../../components/Title';
import './style.css';
// import { Bar, Doughnut } from 'react-chartjs-2';
// import { ChartCard } from '../../components/Charts';
import ChartsSection from '../../components/Charts';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
// Removido import QRCode devido a problemas de módulo não encontrado

import PIX from "react-qrcode-pix";
export function ResumoComissoes() {
    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [eixibirSomentePendentes, setEixibirSomentePendentes] = useState(true);
    const [exibirSomentePendentesRepresentantesComerciais, setExibirSomentePendentesRepresentantesComerciais] = useState(false);

    const [employees, setEmployees] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = employees.filter((employee: any) => {
        if (employee.empresa) {
            const cpfClean = employee.empresa.replace(/[\.-]/g, ''); // Remove '.' e '-'

            return (
                employee.empresa.toLowerCase().includes(searchQuery.toLowerCase()) ||
                cpfClean.includes(searchQuery) ||
                employee.id.toString().includes(searchQuery)
            );
        }
    });
    const [idSelected, setIdSelected] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    // Function to load companies
    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const loadEmployees = async (companyId: any) => {
        try {
            const response = await api.get('pagamentos/listarResumoPagamentos')
            console.log(response.data)
            setEmployees(response.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };
    // Load companies initially
    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadEmployees(selectedCompany);
    }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

    const handleSelectCompany = (id: any) => {
        setSelectedCompany(id);
    };

    const handleStatusChange = async (employeeId: any, currentStatus: any) => {
        const newStatus = currentStatus === true ? false : true;

        try {
            await api.post('status-funcionarios', { id_empresa: selectedCompany, id_funcionario: employeeId, status: newStatus });
            // Reload employees to reflect the change
            loadEmployees(selectedCompany);
        } catch (error) {
            console.error("Error updating employee status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const getMesReferente = () => {
        const dataAtual = new Date();
        const mes = dataAtual.toLocaleDateString('pt-BR', { month: 'long' });
        const ano = dataAtual.toLocaleDateString('pt-BR', { year: '2-digit' });
        const mesReferente = `${mes.charAt(0).toUpperCase() + mes.slice(1)}/${ano}`;
        return mesReferente;
    }

    const getAnoReferente = () => {
        const dataAtual = new Date();
        const ano = dataAtual.toLocaleDateString('pt-BR', { year: '2-digit' });
        return ano;
    }
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);


    const [_, setDocumento] = useState("");
    const [nome, setNome] = useState("");
    const [chave_pix, setChave_pix] = useState("");
    const [totalPagar, setTotalPagar] = useState(0);
    const [idCredenciado, setIdCredenciado] = useState(0);

    const handleShow = (documento: string, nome: string, chave_pix: string, total_comissao: number, id_credenciado: number) => {
        setShow(true);
        setDocumento(documento);
        setNome(nome);
        setChave_pix(chave_pix);
        setTotalPagar(total_comissao);
        setIdCredenciado(id_credenciado);
    }
    const handleShowRepresentantesComerciais = (documento: string, nome: string, chave_pix: string, total_comissao: number, id_credenciado: number) => {
        setShowRepresentantesComerciais(true);
        setDocumento(documento);
        setNome(nome);
        setChave_pix(chave_pix);
        setTotalPagar(total_comissao);
        setIdCredenciado(id_credenciado);
    }
    const handleConfirmRepresentantesComerciais = async () => {
        if (fileComprovante) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64Image = String(reader.result).split(',')[1];
                try {
                    await api.post('atualizar-comprovante-pagamento-representante', {
                        id_representante: idCredenciado,
                        mes_referente: mesReferente,
                        comprovante_pagamento: base64Image
                    });
                    setShowRepresentantesComerciais(false);
                    loadComissoesCredenciado();
                } catch (error) {
                }
            };
            reader.readAsDataURL(fileComprovante);
        }
    }
    const handleConfirm = async () => {
        if (fileComprovante) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64Image = String(reader.result).split(',')[1];
                try {
                    await api.post('atualizar-comprovante-pagamento-credenciado', {
                        id_credenciado: idCredenciado,
                        mes_referente: mesReferente,
                        comprovante_pagamento: base64Image
                    });
                    handleClose();
                    loadComissoesCredenciado();
                } catch (error) {
                }
            };
            reader.readAsDataURL(fileComprovante);
        }
    }

    const [showVendas, setShowVendas] = useState(false);
    const [showRepresentantesComerciais, setShowRepresentantesComerciais] = useState(false);

    const handleCloseRepresentantesComerciais = () => {
        setShowRepresentantesComerciais(false);
    }

    const handleCloseVendas = () => {
        setDocumento("");
        setNome("");
        setChave_pix("");
        setTotalPagar(0);
        setIdCredenciado(0);
        setShowVendas(false);
    }

    const handleShowVendas = (pedidos: any) => {
        setShowVendas(true);
        setSelectedCredenciadoVendas(pedidos);
    }

    const [showVendasRepresentantesComerciais, setShowVendasRepresentantesComerciais] = useState(false);
    const [selectedRepresentantesComerciaisVendas, setSelectedRepresentantesComerciaisVendas] = useState([]);

    const handleCloseVendasRepresentantesComerciais = () => {
        setShowVendasRepresentantesComerciais(false);
        setSelectedRepresentantesComerciaisVendas([]);
    }

    const handleShowVendasRepresentantesComerciais = (pedidos: any) => {
        setShowVendasRepresentantesComerciais(true);
        setSelectedRepresentantesComerciaisVendas(pedidos);
    }

    const [fileComprovante, setFileComprovante] = useState(null);
    const handleFileComprovanteUpload = (event: any) => {
        const file = event.target.files[0];
        if (file && file.type === "application/pdf") {
            setFileComprovante(file);
            setAlert({ show: false, message: '', variant: 'success' });
        } else {
            setAlert({ show: true, message: 'Por favor, anexe um documento PDF.', variant: 'danger' });
            setFileComprovante(null);
        }
    };

    const [minimalPix, setMinimalPix] = useState("");
    useEffect(() => {
        if (!show) {
            setFileComprovante(null)
        }
    }, [show])
    const [mesReferente, setMesReferente] = useState(getMesReferente());
    const [mesReferenteRepresentantesComerciais, setMesReferenteRepresentantesComerciais] = useState(getMesReferente());

    const [filteredComissoesCredenciado, setFilteredComissoesCredenciado] = useState([]);
    const [filteredComissoesRepresentantesComerciais, setFilteredComissoesRepresentantesComerciais] = useState([]);

    const handleMesReferenteChange = (s: string) => {
        setMesReferente(s);
    }
    const handleMesReferenteRepresentantesComerciaisChange = (event: string) => {
        setMesReferenteRepresentantesComerciais(event);
    }
    const [comissoesCredenciado, setComissoesCredenciado] = useState([]);
    const [comissoesRepresentantesComerciais, setComissoesRepresentantesComerciais] = useState([]);


    const loadComissoesCredenciado = async () => {
        try {
            const response = await api.get(`listar-todas-comissoes-por-mes-credenciados`);
            setComissoesCredenciado(response.data);
            const responseRepresentantesComerciais = await api.get(`listar-todas-comissoes-por-mes-representantes-comerciais`);
            setComissoesRepresentantesComerciais(responseRepresentantesComerciais.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };
    useEffect(() => {
        loadComissoesCredenciado();
    }, [])


    const [selectedCredenciadoVendas, setSelectedCredenciadoVendas] = useState([]);
    const [comissoesCredenciadoFiltradas, setComissoesCredenciadoFiltradas] = useState([]);
    const [comissoesRepresentantesComerciaisFiltradas, setComissoesRepresentantesComerciaisFiltradas] = useState([]);

    useEffect(() => {
        const comissoesCredenciadoFiltradas = (comissoesCredenciado as Record<string, any>)[mesReferente]
        if (comissoesCredenciadoFiltradas) {
            setComissoesCredenciadoFiltradas(comissoesCredenciadoFiltradas);
        } else {
            setComissoesCredenciadoFiltradas([]);
        }
    }, [mesReferente, comissoesCredenciado])

    useEffect(() => {
        const comissoesRepresentantesComerciaisFiltradas = (comissoesRepresentantesComerciais as Record<string, any>)[mesReferenteRepresentantesComerciais];
        if (comissoesRepresentantesComerciaisFiltradas) {
            setComissoesRepresentantesComerciaisFiltradas(comissoesRepresentantesComerciaisFiltradas);
        } else {
            setComissoesRepresentantesComerciaisFiltradas([]);
        }
    }, [mesReferenteRepresentantesComerciais, comissoesRepresentantesComerciais])

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={showVendasRepresentantesComerciais} onHide={handleCloseVendasRepresentantesComerciais} size='xl'>
                    <Modal.Header closeButton>
                        <Modal.Title>Vendas realizadas</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <CardContent>
                            <Row className='mb-4'>
                                <Col sm={10} className='my-2 d-flex align-items-end'>
                                    <span>Página {currentPage} de {Math.ceil(selectedRepresentantesComerciaisVendas.length / employeesPerPage)}</span>

                                </Col>
                                <Col sm={2} className='my-2 d-flex justify-content-end'>
                                    <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                        {employeesPerPageOptions.map((option) => (
                                            <Options
                                                key={option}
                                                value={option}
                                                name={`${option} por página`}
                                                selected={option === employeesPerPage}
                                            />
                                        ))}
                                    </Select>

                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Table>
                                        <THeader>
                                            <ThCell>Cliente</ThCell>
                                            <ThCell>Mês Referente</ThCell>
                                            <ThCell>Plano Adquirido</ThCell>
                                            <ThCell>Total da Venda</ThCell>
                                            <ThCell>Comissão a ser Paga</ThCell>
                                        </THeader>
                                        <TBody>
                                            {selectedRepresentantesComerciaisVendas.length > 0 ? (
                                                selectedRepresentantesComerciaisVendas.map((venda: any) => (
                                                    <TGroup key={venda.id_pedido}>
                                                        <TRow>
                                                            <TCell>{venda.email}</TCell>
                                                            <TCell>{mesReferente}</TCell>
                                                            <TCell>{venda.produto}</TCell>
                                                            <TCell>R$ {venda.valor_pago.toFixed(2)}</TCell>
                                                            <TCell>R$ {venda.valor_comissao.toFixed(2)}</TCell>
                                                        </TRow>
                                                    </TGroup>
                                                ))
                                            ) : (
                                                <TGroup>
                                                    <TRow>
                                                        <TCell colSpan={6} className="text-center">
                                                            Não há dados para serem mostrados
                                                        </TCell>
                                                    </TRow>
                                                </TGroup>
                                            )}

                                        </TBody>
                                    </Table>
                                </Col>
                                <Col className='d-flex justify-content-center mt-4'>
                                    <div className="pagination">
                                        <Pagination>
                                            {paginationItems()}
                                        </Pagination>
                                    </div>
                                </Col>
                            </Row>
                        </CardContent>

                    </Modal.Body>
                </Modal>
                <Modal show={showVendas} onHide={handleCloseVendas} size='xl'>
                    <Modal.Header closeButton>
                        <Modal.Title>Vendas realizadas</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <CardContent>
                            <Row className='mb-4'>
                                <Col sm={10} className='my-2 d-flex align-items-end'>
                                    <span>Página {currentPage} de {Math.ceil(selectedCredenciadoVendas.length / employeesPerPage)}</span>

                                </Col>
                                <Col sm={2} className='my-2 d-flex justify-content-end'>
                                    <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                        {employeesPerPageOptions.map((option) => (
                                            <Options
                                                key={option}
                                                value={option}
                                                name={`${option} por página`}
                                                selected={option === employeesPerPage}
                                            />
                                        ))}
                                    </Select>

                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Table>
                                        <THeader>
                                            <ThCell>Cliente</ThCell>
                                            <ThCell>Mês Referente</ThCell>
                                            <ThCell>Plano Adquirido</ThCell>
                                            <ThCell>Total da Venda</ThCell>
                                            <ThCell>Comissão a ser Paga</ThCell>
                                        </THeader>
                                        <TBody>
                                            {selectedCredenciadoVendas.length > 0 ? (
                                                selectedCredenciadoVendas.map((venda: any) => (
                                                    <TGroup key={venda.id_pedido}>
                                                        <TRow>
                                                            <TCell>{venda.email}</TCell>
                                                            <TCell>{mesReferente}</TCell>
                                                            <TCell>{venda.produto}</TCell>
                                                            <TCell>R$ {venda.valor_pago.toFixed(2)}</TCell>
                                                            <TCell>R$ {venda.valor_comissao.toFixed(2)}</TCell>
                                                        </TRow>
                                                    </TGroup>
                                                ))
                                            ) : (
                                                <TGroup>
                                                    <TRow>
                                                        <TCell colSpan={6} className="text-center">
                                                            Não há dados para serem mostrados
                                                        </TCell>
                                                    </TRow>
                                                </TGroup>
                                            )}

                                        </TBody>
                                    </Table>
                                </Col>
                                <Col className='d-flex justify-content-center mt-4'>
                                    <div className="pagination">
                                        <Pagination>
                                            {paginationItems()}
                                        </Pagination>
                                    </div>
                                </Col>
                            </Row>
                        </CardContent>

                    </Modal.Body>
                </Modal>
                <Modal show={show} onHide={handleClose} size='xl'>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de Pagamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                        <p style={{ fontSize: '20px' }}>Beneficiário: <b>{nome}</b><br />
                            Valor: <b>R$ {totalPagar}</b></p>
                        <PIX
                            pixkey={chave_pix || ''}
                            merchant={nome || ''}
                            city='Curitiba'
                            onLoad={setMinimalPix}
                        />
                        {minimalPix && (
                            <p style={{ textAlign: 'center', fontSize: '9px', paddingTop: '10px' }}>{minimalPix}</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Form.Group controlId="custom-file" style={{ textAlign: 'center' }}>
                            <Form.Label>Anexar documento para confirmar o pagamento</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileComprovanteUpload}
                            />
                        </Form.Group>
                        {alert.show && (
                            <div className={`alert alert-${alert.variant}`} role="alert" style={{ marginTop: '10px' }}>
                                {alert.message}
                            </div>
                        )}
                        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                            <Button variant="secondary" onClick={handleClose}>
                                Fechar
                            </Button>
                            {fileComprovante && (
                                <Button variant="primary" onClick={handleConfirm}>
                                    Confirmar Pagamento
                                </Button>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={showRepresentantesComerciais} onHide={handleCloseRepresentantesComerciais} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de Pagamento </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                        <p style={{ fontSize: '20px' }}>Beneficiário: <b>{nome}</b><br />
                            Valor: <b>R$ {totalPagar}</b></p>
                        <PIX
                            pixkey={chave_pix || ''}
                            merchant={nome || ''}
                            city='Curitiba'
                            onLoad={setMinimalPix}
                        />
                        {minimalPix && (
                            <p style={{ textAlign: 'center', fontSize: '9px', paddingTop: '10px' }}>{minimalPix}</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Form.Group controlId="custom-file" style={{ textAlign: 'center' }}>
                            <Form.Label>Anexar documento para confirmar o pagamento</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileComprovanteUpload}
                            />
                        </Form.Group>
                        {alert.show && (
                            <div className={`alert alert-${alert.variant}`} role="alert" style={{ marginTop: '10px' }}>
                                {alert.message}
                            </div>
                        )}
                        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                            <Button variant="secondary" onClick={() => setShowRepresentantesComerciais(false)}>
                                Fechar
                            </Button>
                            {fileComprovante && (
                                <Button variant="primary" onClick={handleConfirmRepresentantesComerciais}>
                                    Confirmar Pagamento
                                </Button>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Resumo das Comissões - Credenciado" />
                    </Row>
                    <Row>
                        <Col md={6} className='my-2 d-flex align-items-end' style={{ float: 'left' }}>
                            <Select id='mesReferenteSelect' value={mesReferente} onSelect={handleMesReferenteChange}>
                                <Options key={`Janeiro/${getAnoReferente()}`} value={`Janeiro/${getAnoReferente()}`} name={`Janeiro/${getAnoReferente()}`} selected={getMesReferente() === `Janeiro/${getAnoReferente()}`} />
                                <Options key={`Fevereiro/${getAnoReferente()}`} value={`Fevereiro/${getAnoReferente()}`} name={`Fevereiro/${getAnoReferente()}`} selected={getMesReferente() === `Fevereiro/${getAnoReferente()}`} />
                                <Options key={`Março/${getAnoReferente()}`} value={`Março/${getAnoReferente()}`} name={`Março/${getAnoReferente()}`} selected={getMesReferente() === `Março/${getAnoReferente()}`} />
                                <Options key={`Abril/${getAnoReferente()}`} value={`Abril/${getAnoReferente()}`} name={`Abril/${getAnoReferente()}`} selected={getMesReferente() === `Abril/${getAnoReferente()}`} />
                                <Options key={`Maio/${getAnoReferente()}`} value={`Maio/${getAnoReferente()}`} name={`Maio/${getAnoReferente()}`} selected={getMesReferente() === `Maio/${getAnoReferente()}`} />
                                <Options key={`Junho/${getAnoReferente()}`} value={`Junho/${getAnoReferente()}`} name={`Junho/${getAnoReferente()}`} selected={getMesReferente() === `Junho/${getAnoReferente()}`} />
                                <Options key={`Julho/${getAnoReferente()}`} value={`Julho/${getAnoReferente()}`} name={`Julho/${getAnoReferente()}`} selected={getMesReferente() === `Julho/${getAnoReferente()}`} />
                                <Options key={`Agosto/${getAnoReferente()}`} value={`Agosto/${getAnoReferente()}`} name={`Agosto/${getAnoReferente()}`} selected={getMesReferente() === `Agosto/${getAnoReferente()}`} />
                                <Options key={`Setembro/${getAnoReferente()}`} value={`Setembro/${getAnoReferente()}`} name={`Setembro/${getAnoReferente()}`} selected={getMesReferente() === `Setembro/${getAnoReferente()}`} />
                                <Options key={`Outubro/${getAnoReferente()}`} value={`Outubro/${getAnoReferente()}`} name={`Outubro/${getAnoReferente()}`} selected={getMesReferente() === `Outubro/${getAnoReferente()}`} />
                                <Options key={`Novembro/${getAnoReferente()}`} value={`Novembro/${getAnoReferente()}`} name={`Novembro/${getAnoReferente()}`} selected={getMesReferente() === `Novembro/${getAnoReferente()}`} />
                                <Options key={`Dezembro/${getAnoReferente()}`} value={`Dezembro/${getAnoReferente()}`} name={`Dezembro/${getAnoReferente()}`} selected={getMesReferente() === `Dezembro/${getAnoReferente()}`} />
                            </Select>
                        </Col>
                        <Col sm={6}>
                            <Form.Check
                                style={{ marginTop: '12px' }}
                                type="checkbox"
                                label={<div style={{ textAlign: 'center', justifyContent: 'center', marginTop: '12px', marginLeft: '10px' }}>Exibir somente pendentes</div>}
                                checked={eixibirSomentePendentes}
                                onChange={() => setEixibirSomentePendentes(!eixibirSomentePendentes)}
                            />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Documento</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Mês Referente</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Total a ser Pago</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Status</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Comprovante Anexado</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(comissoesCredenciadoFiltradas).length > 0 ? (
                                                Object.entries(comissoesCredenciadoFiltradas).map(([mesAno, dados]: [string, any]) => (
                                                    <tr key={mesAno} style={{ textAlign: 'center' }}>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{dados.nome_credenciado}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{dados.documento}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{mesReferente}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>R$ {dados.total_comissao.toFixed(2)}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                            {dados.comprovante_pagamento_credenciado[0] ? 'Pago' : <p style={{ color: 'red' }}>Pendente</p>}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                            {dados.comprovante_pagamento_credenciado[0] ? (
                                                                <a href={`data:application/pdf;base64,${encodeURIComponent(dados.comprovante_pagamento_credenciado[0])}`} download="comprovante_pagamento.pdf">
                                                                    Baixar Comprovante
                                                                </a>
                                                            ) : (
                                                                'Sem Comprovante'
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }} className='d-flex flex-column align-items-center justify-content-center'>
                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                <Button variant='outline-main' className='mb-2' style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleShowVendas(dados.pedidos)}>
                                                                    <ManageSearchIcon />
                                                                    <p style={{ marginLeft: '8px', fontSize: '13px' }}>Vendas</p>
                                                                </Button>
                                                                {!dados.comprovante_pagamento_credenciado[0] && (
                                                                    <Button variant='outline-main' style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleShow(dados.documento, dados.nome_credenciado, dados.chave_pix, dados.total_comissao, Number(dados.id_credenciado))}>
                                                                        <PriceCheckIcon />
                                                                        <p style={{ marginLeft: '8px', fontSize: '13px' }}>Pagar</p>
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Resumo das Comissões - Representantes Comerciais" />
                    </Row>
                    <Row>
                        <Col md={6} className='my-2 d-flex align-items-end' style={{ float: 'left' }}>
                            <Select id='mesReferenteSelect' value={mesReferenteRepresentantesComerciais} onSelect={handleMesReferenteRepresentantesComerciaisChange}>
                                <Options key={`Janeiro/${getAnoReferente()}`} value={`Janeiro/${getAnoReferente()}`} name={`Janeiro/${getAnoReferente()}`} selected={getMesReferente() === `Janeiro/${getAnoReferente()}`} />
                                <Options key={`Fevereiro/${getAnoReferente()}`} value={`Fevereiro/${getAnoReferente()}`} name={`Fevereiro/${getAnoReferente()}`} selected={getMesReferente() === `Fevereiro/${getAnoReferente()}`} />
                                <Options key={`Março/${getAnoReferente()}`} value={`Março/${getAnoReferente()}`} name={`Março/${getAnoReferente()}`} selected={getMesReferente() === `Março/${getAnoReferente()}`} />
                                <Options key={`Abril/${getAnoReferente()}`} value={`Abril/${getAnoReferente()}`} name={`Abril/${getAnoReferente()}`} selected={getMesReferente() === `Abril/${getAnoReferente()}`} />
                                <Options key={`Maio/${getAnoReferente()}`} value={`Maio/${getAnoReferente()}`} name={`Maio/${getAnoReferente()}`} selected={getMesReferente() === `Maio/${getAnoReferente()}`} />
                                <Options key={`Junho/${getAnoReferente()}`} value={`Junho/${getAnoReferente()}`} name={`Junho/${getAnoReferente()}`} selected={getMesReferente() === `Junho/${getAnoReferente()}`} />
                                <Options key={`Julho/${getAnoReferente()}`} value={`Julho/${getAnoReferente()}`} name={`Julho/${getAnoReferente()}`} selected={getMesReferente() === `Julho/${getAnoReferente()}`} />
                                <Options key={`Agosto/${getAnoReferente()}`} value={`Agosto/${getAnoReferente()}`} name={`Agosto/${getAnoReferente()}`} selected={getMesReferente() === `Agosto/${getAnoReferente()}`} />
                                <Options key={`Setembro/${getAnoReferente()}`} value={`Setembro/${getAnoReferente()}`} name={`Setembro/${getAnoReferente()}`} selected={getMesReferente() === `Setembro/${getAnoReferente()}`} />
                                <Options key={`Outubro/${getAnoReferente()}`} value={`Outubro/${getAnoReferente()}`} name={`Outubro/${getAnoReferente()}`} selected={getMesReferente() === `Outubro/${getAnoReferente()}`} />
                                <Options key={`Novembro/${getAnoReferente()}`} value={`Novembro/${getAnoReferente()}`} name={`Novembro/${getAnoReferente()}`} selected={getMesReferente() === `Novembro/${getAnoReferente()}`} />
                                <Options key={`Dezembro/${getAnoReferente()}`} value={`Dezembro/${getAnoReferente()}`} name={`Dezembro/${getAnoReferente()}`} selected={getMesReferente() === `Dezembro/${getAnoReferente()}`} />
                            </Select>
                        </Col>
                        <Col sm={6}>
                            <Form.Check
                                style={{ marginTop: '12px' }}
                                type="checkbox"
                                label={<div style={{ textAlign: 'center', justifyContent: 'center', marginTop: '12px', marginLeft: '10px' }}>Exibir somente pendentes</div>}
                                checked={exibirSomentePendentesRepresentantesComerciais}
                                onChange={() => setExibirSomentePendentesRepresentantesComerciais(!exibirSomentePendentesRepresentantesComerciais)}
                            />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Documento</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Mês Referente</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Total a ser Pago</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Status</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Comprovante Anexado</th>
                                            <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(comissoesRepresentantesComerciaisFiltradas).length > 0 ? (
                                            Object.entries(comissoesRepresentantesComerciaisFiltradas).map(([mesAno, dados]: [string, any]) => (
                                                <tr key={mesAno} style={{ textAlign: 'center' }}>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{dados.nome_credenciado}</td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{dados.documento}</td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{mesReferente}</td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>R$ {dados.total_comissao.toFixed(2)}</td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {dados.comprovante_pagamento[0] ? 'Pago' : <p style={{ color: 'red' }}>Pendente</p>}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {dados.comprovante_pagamento[0] ? (
                                                            <a href={`data:application/pdf;base64,${encodeURIComponent(dados.comprovante_pagamento[0])}`} download="comprovante_pagamento.pdf">
                                                                Baixar Comprovante
                                                            </a>
                                                        ) : (
                                                            'Sem Comprovante'
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal', borderTop: '1px solid lightgray' }} className='d-flex flex-column align-items-center justify-content-center'>
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                            <Button variant='outline-main' className='mb-2' style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleShowVendasRepresentantesComerciais(dados.pedidos)}>
                                                                <ManageSearchIcon />
                                                                <p style={{ marginLeft: '8px', fontSize: '13px' }}>Vendas</p>
                                                            </Button>
                                                            {!dados.comprovante_pagamento[0] && (
                                                                <Button variant='outline-main' style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleShowRepresentantesComerciais(dados.documento, dados.nome_credenciado, dados.chave_pix, dados.total_comissao, Number(dados.id_credenciado))}>
                                                                    <PriceCheckIcon />
                                                                    <p style={{ marginLeft: '8px', fontSize: '13px' }}>Pagar</p>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={7} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                    Não há dados para serem mostrados
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
        </div >
    );
}